export default function HeroSection({className, ...props}) {

    return (

        <div className={`bg-[#F0F7FF] flex flex-row justify-center items-center p-[3rem] lg:p-[6rem]  ${className}`}>
            <div className={"flex flex-col justify-center items-center gap-3  flex-[2]"}>
                <p className={"text-xl lg:text-3xl font-poppins font-extrabold text-black"}>
                    Hello! Welcome to DET Study Support.
                </p>
                <p className={"text-xs opacity-0 lg:text-sm text-gray-500"}>
                    Lorem ipsum dolor sit amet consectetur. Semper duis vitae eget facilisis. Sagittis at adipiscing hendrerit turpis urna sapien.
                </p>
            </div>

        </div>

    )
}